import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { BasePathProvider, joinBasePath } from '@shared/routing'
import './index.scss'
import App from './App'
import { DEFAULT_LANGUAGE } from './i18n'
import { GTM_ID } from './shared/api/credentials'
import { initGtm } from './utils/gtm'

interface AlzaLandingProps {
  /** Absolute path this landing is mounted at */
  basePath: string
}

export const AlzaLanding = ({ basePath }: AlzaLandingProps) => {
  useEffect(() => {
    initGtm(GTM_ID)
  }, [])

  return (
    <BasePathProvider value={basePath}>
      <Routes>
        <Route element={<App />} path=":lang" />
        <Route
          element={<Navigate replace to={joinBasePath(basePath, DEFAULT_LANGUAGE)} />}
          path="*"
        />
      </Routes>
    </BasePathProvider>
  )
}

AlzaLanding.displayName = 'AlzaLanding'
